export const GET_SCANS = 'Get_Scans';